import { formatNumToStandardNotation } from '@modules/common/utils';
import { useIsFeedbackRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import { Stack, Typography } from '@mui/material';

interface SearchAnalysesFeedbackListHeaderProps {
  totalFeedbacks?: number;
  isSummaryView: boolean;
  title?: string;
}

export const SearchAnalysesFeedbackListHeader = ({
  totalFeedbacks,
  isSummaryView,
  title = 'Feedback Records',
}: SearchAnalysesFeedbackListHeaderProps) => {
  const isFeedbackRedesignEnabled = useIsFeedbackRedesignEnabled();

  const titleToDisplay =
    isFeedbackRedesignEnabled && isSummaryView
      ? 'Summary of Feedback Records'
      : title;

  return (
    <Stack height="100%" justifyContent="center">
      <Typography
        variant="body2"
        fontWeight={500}
        color={
          isFeedbackRedesignEnabled && isSummaryView ? 'info.main' : undefined
        }
      >
        {titleToDisplay}
        {totalFeedbacks !== undefined
          ? ` (${formatNumToStandardNotation(totalFeedbacks)})`
          : ''}
      </Typography>
      {!!totalFeedbacks && (
        <Typography variant="caption" color="text.disabled">
          Sorted by most recent
        </Typography>
      )}
    </Stack>
  );
};
